import { DeepPartial, InstallPackage } from 'types';

import { api } from './api';

export const installPackageApi = api.injectEndpoints({
  endpoints: (build) => ({
    saveInstallPackage: build.mutation<any, { accountId: string; savePackage: DeepPartial<InstallPackage> }>({
      query: ({ accountId, savePackage }) => ({
        url: `v2/accounts/${accountId}/install-package/save`,
        method: 'POST',
        body: { ...savePackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'AccountAdders', id: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
        { type: 'Checklists' as const },
      ],
    }),
    submitInstallPackage: build.mutation<any, { accountId: string; installPackage: InstallPackage }>({
      query: ({ accountId, installPackage }) => ({
        url: `v2/accounts/${accountId}/install-package/submit`,
        method: 'POST',
        body: { ...installPackage },
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: 'Accounts', id: arg?.accountId },
        { type: 'Queues', accountId: arg?.accountId },
        { type: 'AccountAdders', id: arg?.accountId },
        { type: 'SystemDesign', id: arg?.accountId },
        { type: 'AccountMilestones', id: arg?.accountId },
        { type: 'Checklists' as const },
      ],
    }),
  }),
});

export const { useSaveInstallPackageMutation, useSubmitInstallPackageMutation } = installPackageApi;
